module.exports = __webpack_public_path__ + "static/media/Roselia_gaussian2.13062bea.png";